import { validIsp, sortIsps } from './utils';
import * as types from '../../actions/types';

export default (state = { isLoggedIn: false, isError: false, isNotFound: false, isLoading: false, assessmentOpen: false }, action) => {
  switch(action.type) {
    case types.SET_LOGGED_IN:
      return { ...state, isLoggedIn: action.isLoggedIn };
    case types.SET_PLAYER_LOADED:
      return { ...state, isLoaded: action.isLoaded };
    case types.SET_PLAYER_LOADING:
      return { ...state, isLoading: action.isLoading };
    case types.SET_PLAYER_LOADING_ERROR:
      return { ...state, isError: true, isLoading: false };
    case types.SET_PLAYER_NOT_FOUND:
      return { ...state, isError: true, isLoading: false, isNotFound: true };
    case types.RECEIVE_PLAYER:
      let newData = { }
      if (action.playerData.loggedIn) {
        newData = {
          ...action.playerData.data,
          location: { location: { ...action.playerData.data.ip_location }, isps: [], data_loaded: false },
          ip_location: { location: { location: { ...action.playerData.data.ip_location }, isps: [], data_loaded: false }, isp: { ...action.playerData.data.ip_isp } },
          isp: { ...action.playerData.data.ip_isp }
        }
        newData.player_stats = newData.player_stats.map(p => {
          let newLoc = { ...p, location: { location: { ...p.location }, isps: [], data_loaded: false } }
          if (p.location.id === newData.location.location.id && p.isp.name === newData.isp.name) {
            newData.stats = [ ...p.stats ]
            newData.ip_location.stats = { ...p.stats }
          }
          return newLoc
        })
      } else {
        newData = { ...action.playerData.data }
        newData.location.unfilteredIsps = sortIsps(newData.location.isps)
        newData.location.isps = sortIsps(newData.location.isps.filter(validIsp))
      }
      newData.isLoaded = action.playerData.isLoaded
      return { ...state, ...newData, isLoading: false };
    case types.SWITCH_PLAYER_LOCATION:
      return { ...state, stats: [], ...action.location }
    case types.RECEIVE_PLAYER_LOCATION:
      let newState = { ...state }
      if (action.playerLocation.location.id === state.location.location.id) {
        newState.location.unfilteredIsps = sortIsps(action.playerLocation.isps)
        newState.location.isps = sortIsps(action.playerLocation.isps.filter(validIsp))
        newState.location.data_loaded = true
        newState.location.unsupported_country = action.playerLocation.unsupported_country
        newState.location.location.city_name = action.playerLocation.location.city_name

        newState.location.unfilteredIsps.forEach(isp => {
          if (isp.name === state.isp.name) {
            newState.isp = { ...isp }
          }
        })
      }
      if (action.playerLocation.location.id === state.ip_location.location.location.id) {
        newState.ip_location.unfilteredIsps = sortIsps(action.playerLocation.isps)
        newState.ip_location.isps = sortIsps(action.playerLocation.isps.filter(validIsp))
        newState.ip_location.data_loaded = true
        newState.ip_location.unsupported_country = action.playerLocation.unsupported_country
        newState.ip_location.location.city_name = action.playerLocation.location.city_name

        newState.location.unfilteredIsps.forEach(isp => {
          if (isp.name === state.ip_isp.name) {
            newState.ip_isp = { ...isp }
          }
        })
      }
      newState.player_stats = newState.player_stats.map(p => {
        if (p.location.location.id === action.playerLocation.location.id) {
          let newLoc = { ...p }
          newLoc.location.unfilteredIsps = sortIsps(action.playerLocation.isps)
          newLoc.location.isps = sortIsps(action.playerLocation.isps.filter(validIsp))
          newLoc.location.data_loaded = true
          newLoc.location.unsupported_country = action.playerLocation.unsupported_country
          newLoc.location.location.city_name = action.playerLocation.location.city_name

          newLoc.location.unfilteredIsps.forEach(isp => {
            if (isp.name === newLoc.isp.name) {
              newLoc.isp = { ...isp }
            }
          })

          return newLoc
        } else {
          return p
        }
      })
      return newState
    case types.OPEN_ASSESSMENT:
      return { ...state, assessmentOpen: true}
    case types.CLOSE_ASSESSMENT:
      return { ...state, assessmentOpen: false}
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/player.js